import React from 'react';

const DownloadBessController = ({
    isOpen, 
    downloadBessControllerPackage,
    onClose,
    title,
    bessControllerList = [],
   }) => {
    const downloadPackage   = (id, fileName) => {
       downloadBessControllerPackage(id, fileName);
      }
    return (
    <se-dialog
            id="dialog-simple-site-created"
            color="alternative"
            size="large"
            open={isOpen}
            can-backdrop="false"
          >
            <se-dialog-header color="primary">{`Download ${title} `} </se-dialog-header>
            <se-dialog-content>
                <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead>
                <tr align="center">
                   <th>Software Name</th>
                                        <th>Version</th>
                                        <th>Device</th>
                                        <th>Description</th>
                                        <th>Modified On</th>
                                        <th>Modified By</th>
                                        <th>File Name</th>
                                        <th>Ecostructure Machine Expert version</th>
                                        <th>Release Date</th>
                                        <th>Action</th>
                </tr>
              </thead>
              <tbody>
              {  bessControllerList &&  bessControllerList?.length > 0  ?
              <>
             {  bessControllerList?.map((item, index) => (
                <tr key={index} align="center"> 
                   <td width="10%">{item.softwareName}</td>
                    <td width="10%">{item.version}</td>
                    <td width="10%">{item.device}</td>
                    <td width="10%">{item.description}</td>
                    <td width="10%">{item.modifiedOn}</td>
                    <td width="10%">{item.modifiedBy}</td>
                    <td width="10%">{item.fileName}</td>
                    <td width="10%">{item.ecostructureVersion}</td>
                    <td width="10%">{item.releaseDate}</td>
                    <td width="10%">
                      <se-icon
                        size="small"
                        color="primary"
                        style={{ cursor: "pointer" }}
                        onClick={()=>{downloadPackage(item.id, item.softwareName);
                        }}
                      >
                        action_download_stroke
                      </se-icon>
                    </td>
                  </tr>))
                  }
              </>:
              <tr> <td className=' text-center' colSpan={10}>No data available</td></tr>
                  
                }
               
              </tbody>
            </table>
            </div>
            </se-dialog-content>
            <se-dialog-footer>
          <se-button onClick={onClose}>Cancel</se-button>
          
        </se-dialog-footer>
          </se-dialog>
  )
};

export default DownloadBessController;